
const __default__ = {
  props: {
    bg: {
      type: String,
      default: 'var(--gray-200)'
    },
    h: {
      type: String,
      default: '0.1rem'
    },
    w: {
      type: String,
      default: '0.1rem'
    },
    m: {
      type: String,
      default: '0.6rem 0'
    },
    vertical: {
      type: Boolean,
      default: false
    },
    dashed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    height () {
      return this.vertical ? '100%' : this.h
    }
  }
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "2eb70899-m": (_ctx.m),
  "2eb70899-height": (_ctx.height),
  "2eb70899-bg": (_ctx.bg),
  "2eb70899-h": (_ctx.h),
  "2eb70899-w": (_ctx.w)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__